import { Box, CardMedia } from "@mui/material";

import { Flag } from "./Flag";

interface MatchupImageProps {
  image?: string;
  home?: string;
  away?: string;
  title?: string;
}

export function MatchupImage({
  image,
  title,
  home,
  away,
}: MatchupImageProps): JSX.Element {
  if (image) {
    return (
      <CardMedia
        component="img"
        src={image}
        title={title}
        alt={title ?? ""}
        sx={{ height: 200, objectFit: "cover" }}
      />
    );
  }

  return (
    <Box sx={{ height: 100, position: "relative" }}>
      <Flag
        country={home}
        style={{ left: 0, border: "1px solid rgba(0, 0, 0, 0.12)", boxSizing: "border-box" }}
      />
      <Flag
        country={away}
        style={{ right: 0, border: "1px solid rgba(0, 0, 0, 0.12)", boxSizing: "border-box" }}
      />
    </Box>
  );
}
